import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { SettingApi } from '../../shared/nestjs/gd-all-in-one/services/setting.api';
import { SettingServiceApi } from '../../shared/sdk';
import { RequestUpdateCompanySettingDto } from '../../shared/nestjs/gd-all-in-one/dto/setting.dto';
import { Observable } from 'rxjs/Observable';
import { AppPreferences } from '../../shared/local/app-preferences.local';

/*
  Generated class for the ChangeAccessBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChangeAccessBloc {

  constructor(
    private storage: Storage,
    private nestApiProvider: NestApiProvider,
    private settingApi: SettingApi,
    private settingServiceApi: SettingServiceApi,
    private appPreferences: AppPreferences,
  ) {

  }

  loadGlobalSettingAccess(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const data = await this.loadSettingAccess().toPromise();
        await this.saveStorage(data);
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  loadSettingAccess(): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.settingApi.getCompanySetting()
            .pipe(
              map(param => param.data)
            )
        } else {
          return this.settingServiceApi.getSetting()
        }
      })
  }

  saveSettingAccess(data: RequestUpdateCompanySettingDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.settingApi.updateCompanySetting(data)
            .pipe(
              map(param => param.data)
            )
        } else {
          return this.settingServiceApi.updateSetting({
            webAbsent: data.webAbsent,
            checkRoot: data.checkRoot,
            attendanceLock: data.attendanceLock,
            cameraLock: data.cameraLock,
            showPosting: data.showPosting,
            checkFakeGPS: data.checkFakeGPS,
          })
        }
      })
  }

  saveStorage(data: any): Promise<any> {
    return new Promise(async (resolve) => {
      this.storage.set("GDAttendanceSetting", JSON.stringify(data));
      this.updateMenuAuth(data);
      resolve(true);
    })
  }

  async getStorage(): Promise<any> {
    return JSON.parse(await this.storage.get('GDAttendanceSetting'));
  }

  async updateMenuAuth(data: any) {
    try {
      const auth = await this.appPreferences.getAuth();
      if (data) {
        auth.companySetting = data;
        await this.appPreferences.setAuth(auth);
      }
    } catch (error) { }
  }

}



// WEBPACK FOOTER //
// ./src/bloc/settings/change-access.bloc.ts